var React = require('react');

function Grid (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3","y":"3","width":"7","height":"7","key":0}),React.createElement("rect",{"x":"14","y":"3","width":"7","height":"7","key":1}),React.createElement("rect",{"x":"14","y":"14","width":"7","height":"7","key":2}),React.createElement("rect",{"x":"3","y":"14","width":"7","height":"7","key":3})]);
}

Grid.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-grid"};

module.exports = Grid;

Grid.default = Grid;
